import { getDiff } from "json-difference";
import { DeepPartial, FieldValues } from "react-hook-form";

import { logAddedFields } from "./logAddedFields";
import { logEditedFields } from "./logEditedFields";
import { logRemovedFields } from "./logRemovedFields";

export const logChanges = <TFieldValues extends FieldValues>(
  previousValues: DeepPartial<TFieldValues> | TFieldValues,
  nextValues: DeepPartial<TFieldValues> | TFieldValues,
): void => {
  const changes = getDiff(previousValues, nextValues);

  if (
    changes.added.length === 0 &&
    changes.edited.length === 0 &&
    changes.removed.length === 0
  ) {
    console.log("\x1B[1mNo changes in state\x1B[m");
  }

  if (changes.added.length > 0) {
    logAddedFields(changes.added);
  }

  if (changes.edited.length > 0) {
    logEditedFields(changes.edited);
  }

  if (changes.removed.length > 0) {
    logRemovedFields(changes.removed);
  }
};
